export class Contato {
    id: number;
    email: string;
    emailAlternativo: string;
    telefonePessoal: string;
    telefoneFixo: string;
}